<template>
    <div class="home_warp">
      <!-- 衣加视频弹窗 -->
      <div class='tan_video' id='tan_video'>
        <video controls="controls"  name="media" id='tan_video1' height="100%" width="100%"><source src="http://bu.dressplus.cn/web/video/index_video.mp4" type="video/mp4"></video>
      </div>
      <div id='black_bg' @click='hidden_video'></div>
      <div class="watch_video hidden-xs-only">
        <div class='index_part1_bg'>
          <video class="video_bg" autoplay='autoplay' loop='loop' src="http://bu.dressplus.cn/web/video/banner_video.mp4"></video>
        </div>
        <div class='index_part1_content1'>
          <div class='index_part1_title'>
            <h1>{{$t('nav.seeyi')}}</h1>
            <div class='index_video_button' id='video_button' @click="video_tan">
              <img id='video_button_img' src='http://bu.dressplus.cn/web/img/video1_button.png' @mouseout='video_tan2_1' @mousemove="video_tan2">
            </div>
          </div>
        </div>
      </div>
      <div class="watch_video_m hidden-sm-and-up">
        <div class='index_part1_bg'>
          <video class="video_bg" autoplay='autoplay' loop='loop' src="http://bu.dressplus.cn/web/video/banner_video.mp4"></video>
        </div>
        <div class="watch_video_m_title">
          人工智能计算机视觉引擎
        </div>
      </div>
      <div class="home_solution_warp clearfix hidden-xs-only">
        <h2 class="solution_title">{{$t('footer.solutions')}}</h2>
        <div class="solution_content clearfix" >
            <div class="solution">
              <div class="solution_img solution_left" @mouseenter="scaleImg(1)" @mouseleave="scaleImg2(1)" >
                <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353515022.jpeg" alt="" ref="solutionLeft">
              </div>
              <div class="solution_text solution_text_l" @mouseenter="scaleImg(1)" @mouseleave="scaleImg2(1)" ref="solutionTextL">
                <p class="solution_text_title">{{$t('solution.Marketing')}}</p>
                <p class="solution_text_title2">{{$t('solution.Intelligent')}}</p>
                <ul class="solution_text_list clearfix">
                  <li>{{$t('solution.Structured')}}</li>
                  <li>{{$t('solution.Scenario')}}</li>
                  <li>{{$t('solution.ImageSearch')}}</li>
                  <li>{{$t('solution.SearchByImage')}}</li>
                  <li>{{$t('solution.Personalized')}}</li>
                  <li>{{$t('solution.Face')}}</li>
                </ul>
                <router-link to="/solution#market" class="solution_text_link">{{$t('footer.more')}}</router-link>
              </div>
            </div>
            <div class="solution">
              <div class="solution_img solution_center" @mouseenter="scaleImg(2)" @mouseleave="scaleImg2(2)" >
                <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353525323.jpeg" alt="" ref="solutionCenter">
              </div>
              <div class="solution_text solution_text_c " @mouseenter="scaleImg(2)" @mouseleave="scaleImg2(2)" ref="solutionTextC">
                <p class="solution_text_title">{{$t('solution.Television')}}</p>
                <p class="solution_text_title2">{{$t('solution.Communication')}}</p>
                <ul class="solution_text_list clearfix">
                  <li>{{$t('solution.Assistant')}}</li>
                  <li>{{$t('solution.Televised')}}</li>
                  <li>{{$t('solution.Valueadded')}}</li>
                  <li>{{$t('solution.Extraction')}}</li>
                  <li>{{$t('solution.Broadcasting')}}</li>
                </ul>
                <router-link to="/solution#tv" class="solution_text_link">{{$t('footer.more')}}</router-link>
              </div>
            </div>
            <div class="solution">
              <div class="solution_img solution_right" @mouseenter="scaleImg(3)" @mouseleave="scaleImg2(3)" >
                <img src="http://bu.dressplus.cn/cdn/media/reports/img/153052353535924.jpeg" alt="" ref="solutionRight">
              </div>
              <div class="solution_text solution_text_r" @mouseenter="scaleImg(3)" @mouseleave="scaleImg2(3)" ref="solutionTextR">
                <p class="solution_text_title">{{$t('solution.CameraAi')}}</p>
                <p class="solution_text_title2">{{$t('solution.Creative')}}</p>
                <ul class="solution_text_list clearfix">
                  <li>{{$t('solution.SmartPhoto')}}</li>
                  <li>{{$t('solution.Virtual')}}</li>
                  <li>{{$t('solution.Dynamic')}}</li>
                  <li>{{$t('solution.Shopping')}}</li>
                  <li>{{$t('solution.Realtime')}}</li>
                </ul>
                <router-link to="/solution#camera" class="solution_text_link">{{$t('footer.more')}}</router-link>
              </div>
            </div>
        </div>
      </div>
      <div class="home_solution_warp clearfix hidden-sm-and-up">
        <h2 class="solution_title">{{$t('footer.solutions')}}</h2>
        <div class="solution_content clearfix" >
          <div class="solution">
            <div class="solution_img solution_left"  >
              <img src="http://bu.dressplus.cn/web/static/image/solution_img4.jpg" alt="">
            </div>
            <div class="solution_text_title_warp">
              <p class="solution_text_title">{{$t('solution.Marketing')}}</p>
              <p class="solution_text_title2">{{$t('solution.Intelligent')}}</p>
              <router-link to="/solution#market" class="solution_text_link">{{$t('footer.more')}}<i></i></router-link>

            </div>
          </div>
          <div class="solution">
            <div class="solution_img solution_center" >
              <img src="http://bu.dressplus.cn/web/static/image/solution_img5.jpg" alt="">
            </div>
            <div class="solution_text_title_warp">
              <p class="solution_text_title">{{$t('solution.Television')}}</p>
              <p class="solution_text_title2">{{$t('solution.Communication')}}</p>
              <router-link to="/solution#tv" class="solution_text_link">{{$t('footer.more')}}<i></i></router-link>
            </div>
          </div>
          <div class="solution">
            <div class="solution_img solution_right" >
              <img src="http://bu.dressplus.cn/web/static/image/solution_img6.jpg" alt="">
            </div>
            <div class="solution_text_title_warp">
              <p class="solution_text_title">{{$t('solution.CameraAi')}}</p>
              <p class="solution_text_title2">{{$t('solution.Creative')}}</p>
              <router-link to="/solution#camera" class="solution_text_link">{{$t('footer.more')}}<i></i></router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="home_product">
        <h2 class="produc_title">{{$t('footer.products')}}</h2>
        <div class="produc_content clearfix" >
          <div class="product">
            <div class="product_bg">
              <img src="http://bu.dressplus.cn/web/static/image/product_icon_2.png" alt="" v-if="showGif2" @mouseenter="mutImg(2)">
              <img src="http://bu.dressplus.cn/web/static/image/product_icon_2.gif" alt="" v-else-if="!showGif2" @mouseleave="outImg(2)">
            </div>
            <div>
              <h3 class="produc_title2">{{$t('product.Computer')}}</h3>
              <!--<p>商品深度建模搜索</p>
              <p>商品精准推荐</p>
              <p>商品检测及类目分析</p>-->
              <router-link :to="{path:'/product',query: {activeName: 'first'}}" class="produc_a">{{$t('home.More')}}<i></i></router-link>
            </div>
          </div>
          <div class="product">
            <div class="product_bg">
              <img src="http://bu.dressplus.cn/web/static/image/product_icon_1.png" alt="" v-if="showGif1" @mouseenter="mutImg(1)">
              <img src="http://bu.dressplus.cn/web/static/image/product_icon_3.gif" alt="" v-else-if="!showGif1" @mouseleave="outImg(1)">
            </div>
            <div class="">
              <h3 class="produc_title2">{{$t('product.Image')}}</h3>
              <!--<p class="produc_p">轮廓分割</p>
              <p>目标检测</p>
              <p>通用物体和场景识别</p>-->
              <router-link :to="{path:'/product',query: {activeName: 'second'}}" class="produc_a">{{$t('home.More')}}<i></i></router-link>

            </div>
          </div>
          <div class="product">
            <div class="product_bg">
              <img src="http://bu.dressplus.cn/web/static/image/product_icon_3.png" alt="" v-if="showGif3" @mouseenter="mutImg(3)">
              <img src="http://bu.dressplus.cn/web/static/image/product_icon_1.gif" alt="" v-else-if="!showGif3" @mouseleave="outImg(3)">
            </div>
            <div>
              <h3 class="produc_title2">{{$t('product.Face')}}</h3>
              <!--<p>人脸识别</p>
              <p>特征分析</p>
              <p>人脸对比</p>
              <p>关键点检测</p>-->
              <router-link :to="{path:'/product',query: {activeName: 'third'}}" class="produc_a">{{$t('home.More')}}<i></i></router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="home_offer hidden-xs-only">
        <h2 class="offer_title">{{$t('home.provide')}}</h2>
        <div class="offer_img">
          <img src="http://bu.dressplus.cn/web/static/image/offer_img.png" alt="">
        </div>
      </div>
      <div class="home_offer hidden-sm-and-up">
        <h2 class="offer_title">{{$t('home.provide')}}</h2>
        <div class="">
          <ul class="offer_img clearfix" ref="offerImg">
            <li v-for="(item,index) in logoListTotal" :key="index">
              <img :src="item.src"  alt="">
            </li>
          </ul>
          <p class="offer_more" @touchstart="more" v-if="!showPackUp">展开更多</p>
          <p class="offer_more" @touchstart="packUp" v-if="showPackUp">收起</p>
        </div>
      </div>
    </div>
</template>

<script>
	import bus from '../utils/bus'
	export default{
    data(){
      return{
        showGif1:true,
        showGif2:true,
        showGif3:true,
        logoListTotal:[
          {src:'http://bu.dressplus.cn/web/static/image/c1.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c2.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c3.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c4.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c5.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c6.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c7.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c8.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c9.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c10.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c11.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c12.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c13.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c14.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c15.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c16.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c17.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c18.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c19.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c20.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c21.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c22.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c23.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c24.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c25.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c26.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c27.png'},
          {src:'http://bu.dressplus.cn/web/static/image/c28.png'},
        ],
        logoList:[],
        showPackUp:false
      }
    },
	  mounted(){
		  bus.$emit('customEvent','home');
	  },
    methods:{
       video_tan2(){
        var video_button_img=document.getElementById('video_button_img');
        video_button_img.src='http://bu.dressplus.cn/web/img/video1_button_on.png';
      },
       video_tan2_1(){
        var video_button_img=document.getElementById('video_button_img');
        video_button_img.src='http://bu.dressplus.cn/web/img/video1_button.png';
      },
      video_tan(){
        var black_bg=document.getElementById('black_bg');
        var cH=window.screen.height;
        // alert(cH);
        black_bg.style.height=cH+'px';
        var tan_video1=document.getElementById('tan_video1');
        var tan_video=document.getElementById('tan_video');
        tan_video.style.display='block';
        tan_video1.style.display='block';
        var body=document.getElementsByTagName('body')[0];
        body.style.overflow='hidden';
        black_bg.style.display='block';
        tan_video1.play();
      },
      hidden_video(){
        var black_bg=document.getElementById('black_bg');
        var tan_video=document.getElementById('tan_video');
        var tan_video1=document.getElementById('tan_video1');
        black_bg.style.display='none';
        tan_video.style.display='none';
        tan_video1.style.display='none';
        var body=document.getElementsByTagName('body')[0];
        body.style.overflow='auto';
        tan_video1.pause();
      },
      mutImg(index){
        if (index === 1){
          this.showGif1 = false
        }else if (index === 2){
          this.showGif2 = false
        }else if (index === 3){
          this.showGif3 = false
        }
      },
      outImg(index){
        if (index === 1){
          this.showGif1 = true
        }else if (index === 2){
          this.showGif2 = true
        }else if (index === 3){
          this.showGif3 = true
        }
      },
      scaleImg(index){
        if (index === 1){
          this.$refs.solutionLeft.style = "transform:scale(1.1)"
          this.$refs.solutionTextL.classList.add('solution_text_h')
        }else if (index === 2){
          this.$refs.solutionCenter.style = "transform:scale(1.1)"
          this.$refs.solutionTextC.classList.add('solution_text_h')

        }else if (index === 3){
          this.$refs.solutionRight.style = "transform:scale(1.1)"
          this.$refs.solutionTextR.classList.add('solution_text_h')

        }
      },
      scaleImg2(index){
        if (index === 1){
          this.$refs.solutionLeft.style = "transform:scale(1)"
          this.$refs.solutionTextL.classList.remove('solution_text_h')
        }else if (index === 2){
          this.$refs.solutionCenter.style = "transform:scale(1)"
          this.$refs.solutionTextC.classList.remove('solution_text_h')

        }else if (index === 3){
          this.$refs.solutionRight.style = "transform:scale(1)"
          this.$refs.solutionTextR.classList.remove('solution_text_h')

        }
      },
      more(){
        this.$refs.offerImg.style = 'height:15.6rem;'
        this.showPackUp = true
      },
      packUp(){
        this.$refs.offerImg.style = 'height:4.62rem;'
        this.showPackUp = false
      }
    },
    created(){
    }
  }
</script>

<style>
  @media screen and (min-width: 768px){
    .index_part1_bg{
      width: 100%;
    }
    .index_part1_bg>.video_bg{
      width: 100%;
    }
    .index_part1_content1{
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      margin-top: -150px;
    }
    .index_part1_title{
      position: relative;
      width: 550px;
      margin: 0 auto;
      height: 200px;
      background: rgba(29,180,255,0.8);
      box-shadow: 0 20px 50px 1px rgba(29,180,255,0.3);
    }
    .index_part1_title h1{
      color: #fff;
      font-size: 30px;
      font-weight: 900;
      letter-spacing: 2px;
      text-align: center;
      font-family: 'SimHei',黑体;
      padding-top: 55px;
    }
    .index_video_button{
      position: absolute;
      bottom: 50px;
      left: 0;
      right: 0;
      width: 115px;
      cursor: pointer;
      margin: 0px auto;
    }
    .index_video_button img{
      display: inline-block;
      width:100%;
    }

    /*视频弹窗*/
    .tan_video{
      width: 700px;
      margin: 0 auto;
      position: fixed;
      top: 50%;
      left: 0;
      right: 0;
      display: none;
      z-index: 100000;
      margin-top: -262px;
    }
    .tan_video video{
      width:100%;
      margin:0 auto;
      display: none;
    }
    #black_bg{
      background: rgba(0,0,0,0.7);
      min-width: 1152px;
      width:100%;
      position: fixed;
      left:0;
      right:0;
      top:0;
      bottom: 0;
      z-index: 100;
      display: none;
    }
    .logo_table1 tr td{
      padding: 20px 29px !important;
    }
    .line2_s,.line1_z{
      display: block;
      width:1000px;
      margin:0 auto;
    }
    /*观看视频*/
    .watch_video{
      /*height: 1080px;*/
      /*background: url("http://bu.dressplus.cn/web/static/image/bj_1.jpg") center no-repeat;*/
      position: relative;

    }
    .title_wrap{
      height: 300px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -150px;
      margin-left: -190px;
      text-align: center;
    }
    .title{
      color: #ffffff;
      font-size: 66px;
      font-weight: 600;
    }
    .watch_btn{
      font-size: 22px;
      display: inline-block;
      background-color: rgba(255,255,255,.6);
      width: 140px;
      height: 45px;
      line-height: 45px;
      text-align: center;
      margin-top: 80px;
      color: #3487ff;
      font-weight: 400;
    }
    /*解决方案*/
    .home_solution_warp{
      position: relative;
      width: 100%;
    }
    .solution_title{
      font-size: 30px;
      width: 80%;
      text-align: center;
      margin: 0px auto;
      padding: 50px 0;
    }
    .solution_content{
      margin-bottom: 0;
    }
    .solution{
      float: left;
      width: 33.3333%;
      position: relative;
      text-align: center;
      height: 740px;
    }

    .solution .solution_img{
      width: 90%;
      vertical-align: middle;
      overflow: hidden;
    }
    .solution_img img{
      width: 100%;
      transition: .3s;
      min-width: 300px;
      vertical-align: middle;
    }
    .solution_text{
      color: #fff;
      text-align: center;
      width: 90%;
      background: rgb(246,247,249);
      height: 45%;
      position: relative;
    }
    .solution_text_l{
      margin-left: 10%;
    }
    .solution_text_c{
      margin: 0px 5%;
    }
    .solution_text_r{
      margin-right: 10%;
    }
    .solution_left{
      margin-left: 10%
    }
    .solution_center{
      margin: 0px 5%;
    }
    .solution_right{
      margin-right: 10%;
    }
    .solution_text_title{
      font-size: 28px;
      padding: 30px 0px 15px 0;
      color: #000;
    }
    .solution_text_title2{
      font-size: 16px;
      padding-bottom: 4%;
      color: #92979e;
    }
    .solution_text_list{
      width: 100%;
      margin: 0 auto;
    }
    .solution_text_list>li{
      box-sizing: border-box;
      white-space: nowrap;
      text-align: center;
      padding: 5px 0;
      font-size: 16px;
      color: #474a4d;
    }
    .solution_text_link{
      position: absolute;
      bottom: 20px;
      left: 40%;
      vertical-align: middle;
      display:inline-block;
      width: 20%;
      min-width: 97px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color:#009BEE;
      border: 1px #009BEE solid;
    }

    .solution_text_h{
      background:  #009BEE;
      opacity: 0.9;
    }
    .solution_text_h .solution_text_title{
      color: #fff;
    }
    .solution_text_h .solution_text_title2{
      color: #fff;
    }
    .solution_text_h .solution_text_list>li{
      color: #fff;
    }
    .solution_text_h .solution_text_link{
      color: #009BEE;
      background-color: #fff;
    }
    /*产品技术*/
    .home_product{
      position: relative;
      background-color: #FAFAFA;
      padding-bottom: 50px;
    }
    .produc_title{
      font-size: 30px;
      width: 80%;
      text-align: center;
      margin: 0px auto;
      padding: 50px 0;
    }
    .produc_content{
      width: 80%;
      text-align: center;
      margin: 0 auto ;
    }
    .product{
      float: left;
      width: 33.3333%;
      min-width: 204px;

    }
    .product_bg img{
      width: 25%;
    }
    .produc_title2{
      font-size: 22px;
      margin: 40px 0 15px;
    }
    .product p{
      font-size: 14px;
      color: #697989;
      padding-bottom: 15px;
    }
    .produc_a{
      color: #009BEE;
      font-size: 14px;

    }
    .produc_a>i{
      display: inline-block;
      vertical-align: middle;

      width: 8px;
      height: 14px;
      background: url("http://bu.dressplus.cn/web/static/image/product_icon_4.png") center no-repeat;
      margin-left: 10px;
    }
    /*提供服务*/
    .home_offer{
      text-align: center;
    }
    .offer_title{
      font-size: 30px;
      padding: 50px 0;
    }
    .offer_img{
      padding-bottom: 50px;
    }
    .offer_img img{
      width: 85%;
      min-width: 655px;
    }
  }
  @media screen and (max-width: 767px){
    .home_warp{
      padding-top: 1.18rem;
    }
    /*视频弹窗*/
    .tan_video{
      width: 700px;
      margin: 0 auto;
      position: fixed;
      top: 50%;
      left: 0;
      right: 0;
      display: none;
      z-index: 100000;
      margin-top: -262px;
    }
    .tan_video video{
      width:100%;
      margin:0 auto;
      display: none;
    }
    #black_bg{
      background: rgba(0,0,0,0.7);
      min-width: 1152px;
      width:100%;
      position: fixed;
      left:0;
      right:0;
      top:0;
      bottom: 0;
      z-index: 100;
      display: none;
    }
    .logo_table1 tr td{
      padding: 20px 29px !important;
    }
    .line2_s,.line1_z{
      display: block;
      width:1000px;
      margin:0 auto;
    }
    /*观看视频*/
    .watch_video_m{
      width: 100%;
      height: 5.6rem;
      /*background: url("http://bu.dressplus.cn/web/static/image/bj_1.jpg") center no-repeat;
      background-size: 100% 100%;*/
      position: relative;
    }
    .index_part1_bg{
      width: 100%;
    }
    .index_part1_bg>.video_bg{
      width: 100%;
    }
    .watch_video_m_title{
      text-align: center;
      font-size: 0.37rem;
      color: #00a6ff;
      width: 50%;
      height: 1.9rem;
      line-height: 1.9rem;
      background: rgba(255,255 ,255,.4);
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -0.8rem;
      margin-left: -25%;
    }
    /*解决方案*/
    .home_solution_warp{
      text-align: center ;

    }
    .solution_title{
      font-size: 0.45rem;
      margin: 0.5rem;
    }
    .solution{
      width: 100%;
      margin: 0px auto;
      overflow: hidden;
    }
    .solution_img{
      height: 5.87rem;
      position: relative;
    }
    .solution_img >img{
      width: 100%;
      text-align: center;
      vertical-align: middle;
    }
    .solution_text{
      color: #fff;
      height: 3.7rem;
      background-color: #485669;

    }
    .solution_text_title_warp{
      /*position: absolute;
      bottom: 30px;*/
      color: #000;
      width: 100%;
      height: 3.79rem;

    }
    .solution_text_title{
      font-size: 0.5rem;
      padding-top: 1rem;
      color: #666;
      font-weight: 600;
    }
    .solution_text_title2{
      font-size: 0.27rem;
      margin-top: 0.4rem;
      margin-bottom: 0.3rem;
      color: #666;
    }
    .solution_text_list{
      width: 90% ;
      margin: 0px auto;
      height: 75%;
      background-color: #485669;
      text-align: center;
    }
    .solution_text_list>li{
      text-align: left;
      float: left;
      height: 18.5%;
      width: 50%;
      border-bottom: 1px solid #fff;
      padding: 0.2rem 0;
      font-size: 0.32rem;
      white-space :  nowrap;
      line-height: 0.6rem;
    }
    .solution_text_list>li:last-child{
      border: none;
    }
    .solution_text_list>li:nth-last-child(2){
       border: none;
     }
    .solution_text_list>li:first-child{
      line-height: 0.75rem;
      padding: 0.25rem 0;
    }
    .solution_text_list>li:nth-child(2){
      padding: 0.25rem 0;
      line-height: 0.75rem;
    }

    .solution_text_link{
      width: 100%;
      color: #00a6ff;
      vertical-align: top;
      display: inline-block;
      font-size: 0.27rem;
      height: 25%;
      line-height: 0.8rem;
    }
    .solution_text_link>i{
      display:inline-block;
      margin-left: 0.2rem;
      width: 0.15rem;
      height: 0.2rem;
      background: url("http://bu.dressplus.cn/web/static/image/product_icon_4W.png") center no-repeat;
      background-size: 100% 100%;
    }
    /*产品技术*/
    .home_product{
      position: relative;
      background-color: #FAFAFA;
      padding-bottom: 0.67rem;
    }
    .produc_title{
      font-size: 0.45rem;
      width: 80%;
      text-align: center;
      margin: 0px auto;
      padding: 1rem 0 0.3rem 0;
    }
    .produc_content{
      width: 80%;
      text-align: center;
      margin: 0 auto ;
    }
    .product{
      min-width: 2.75rem;
      margin: 0.8rem auto;
    }
    .product_bg img{
      width: 30%;
    }
    .produc_title2{
      font-size: 0.4rem;
      margin: 0.4rem 0;
      font-weight: 600;
      color: #666;
    }
    .product p{
      font-size: 0.27rem;
      color: #666;
      padding-bottom: 0.2rem;
    }
    .produc_a{
      color: #009BEE;
      font-size: 0.19rem;
      vertical-align: middle;
    }
    .produc_a>i{
      display: inline-block;
      vertical-align: middle;
      width: 0.11rem;
      height: 0.19rem;
      background: url("http://bu.dressplus.cn/web/static/image/product_icon_4.png") center no-repeat;
      margin-left: 0.13rem;
      background-size: 100% 100%;
    }
    /*合作*/
    .offer_title{
      text-align: center;
      font-size: 0.45rem;
      margin: 1rem 0;
    }
    .offer_img{
      width: 95%;
      margin: 0px auto;
      height: 4.62rem;
      overflow: hidden;
      transition: height .3s linear
    }
    .offer_img>li{
      box-sizing: border-box;
      width: 2.95rem;
      border: 1px solid #ccc;
      float: left;
      margin: 0.1rem;
    }
    .offer_img img{
      vertical-align: middle;
      width: 100%;
    }
    .offer_more{
      width: 95%;
      font-size: 0.35rem;
      color: #009BEE;
      text-align: right;
      margin: 0.3rem 0 1rem 0;
    }
  }
  @media screen and (min-width: 768px)and (max-width: 1400px){
    .solution{
      float: left;
      width: 33.3333%;
      position: relative;
      text-align: center;
      height: 540px;
    }

    .solution .solution_img{
      width: 90%;
      vertical-align: middle;
      overflow: hidden;
    }
    .solution_img img{
      width: 100%;
      transition: .3s;
      min-width: 300px;
      vertical-align: middle;
    }
    .solution_text{
      color: #fff;
      text-align: center;
      width: 90%;
      background: rgb(246,247,249);
      height: 55%;
      position: relative;
    }
    .solution_text_l{
      margin-left: 10%;
    }
    .solution_text_c{
      margin: 0px 5%;
    }
    .solution_text_r{
      margin-right: 10%;
    }
    .solution_left{
      margin-left: 10%
    }
    .solution_center{
      margin: 0px 5%;
    }
    .solution_right{
      margin-right: 10%;
    }
    .solution_text_title{
      font-size: 28px;
      padding: 30px 0px 15px 0;
      color: #000;
    }
    .solution_text_title2{
      font-size: 16px;
      padding-bottom: 4%;
      color: #92979e;
    }
    .solution_text_list{
      width: 100%;
      margin: 0 auto;
    }
    .solution_text_list>li{
      box-sizing: border-box;
      white-space: nowrap;
      text-align: center;
      padding: 5px 0;
      font-size: 12px;
      color: #474a4d;
    }
    .solution_text_link{
      position: absolute;
      bottom: 20px;
      left: 40%;
      vertical-align: middle;
      display:inline-block;
      width: 20%;
      height: 30px;
      text-align: center;
      line-height: 30px;
      color:#009BEE;
      border: 1px #009BEE solid;
      min-width: 97px;
    }

    .solution_text_h{
      background:  #009BEE;
      opacity: 0.9;
    }
    .solution_text_h .solution_text_title{
      color: #fff;
    }
    .solution_text_h .solution_text_title2{
      color: #fff;
    }
    .solution_text_h .solution_text_list>li{
      color: #fff;
      font-size: 12px;
    }
    .solution_text_h .solution_text_link{
      color: #009BEE;
      background-color: #fff;
    }
  }
  @media screen and (max-width: 1400px) {
    .index_part1_title {
      width: 550px;
      height: 200px;
    }
    .index_part1_content1 {
      margin-top: -150px;
    }

    .index_video_button {
      bottom: 30px;
      width: 115px;
    }
  }
  @media screen and (min-width: 1400px) and (max-width:1600px) {
    .index_part1_title {
      width: 800px;
      height: 290px;
    }

    .index_video_button {
      width: 135px;
      bottom: 40px;
    }

    .index_part1_content1 {
      margin-top: -180px;
    }

    .index_part1_title h1 {
      font-size: 34px;
      padding-top: 60px;
    }
  }
  @media screen  and (min-width:1600px) {
    .index_part1_title {
      width: 900px;
      height: 334px;
    }

    .index_part1_content1 {
      margin-top: -200px;
    }

    .index_video_button {
      width: 155px;
      bottom: 60px;
    }

    .index_part1_title h1 {
      font-size: 43px;
      padding-top: 85px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/home.vue